import { Injectable, NgZone } from '@angular/core';
import { fromEvent, merge, Subscription, timer } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class IdleService {
  private userActivitySub?: Subscription;
  private timeoutSub?: Subscription;
  private readonly timeoutMs = 30 * 60 * 1000; // 30 minutes

  constructor(private ngZone: NgZone, private authService: AuthService) {}

  startWatching() {
    // run outside Angular to avoid change detection storms
    this.ngZone.runOutsideAngular(() => {
      const mouseMove$ = fromEvent(document, 'mousemove');
      const keyDown$ = fromEvent(document, 'keydown');
      const click$ = fromEvent(document, 'click');
      const activity$ = merge(mouseMove$, keyDown$, click$);

      this.userActivitySub = activity$.subscribe(() => this.resetTimer());
      this.resetTimer();
    });
  }

  stopWatching() {
    this.userActivitySub?.unsubscribe();
    this.timeoutSub?.unsubscribe();
  }

  private resetTimer() {
    this.timeoutSub?.unsubscribe();
    this.timeoutSub = timer(this.timeoutMs).subscribe(() => this.onTimeout());
  }

  private onTimeout() {
    // perform logout via AuthService
    this.ngZone.run(() => {
      this.authService.logout();
    });
    this.stopWatching();
  }
}
